import _L from "../../utils/Labels";
import { _GetTiempoTranscurrido } from "../../utils/Time";
import { _DICT_GRUPO_ALUMNOS_MAP } from "../services/Alumno";
import { IAlumno } from "./Entities";
import { ModelAdapter } from "./MBase";

export interface IProximidadTutorItem {
    ApMaterno: string
    ApPaterno: string
    DistanciaMetros: number
    Estado: EEstadoProximidad;
    /** @example "2026-04-01T02:06:37.818Z" */
    FechaPosicion: string
    IdEscuela: number
    IdTutor: number
    Nombre: string
    AlumnosAsignados: number[]
}

export enum EEstadoProximidad {
    EN_CAMINO = 1,
    EN_ZONA_ESCOLAR = 2,
    LLEGADA = 3,
    ABANDONO_ZONA = 4,
    CANCELADO = 5,
    COMPLETADO = 6,
}

export class MProximidadTutorItem extends ModelAdapter<IProximidadTutorItem> implements IProximidadTutorItem {
    ApMaterno: string
    ApPaterno: string
    DistanciaMetros: number
    Estado: EEstadoProximidad;
    FechaPosicion: string
    IdEscuela: number
    IdTutor: number
    Nombre: string
    AlumnosAsignados: number[]

    IdGrupo?: number | undefined;
    AlumnosFiltrados?: IAlumno[] | undefined;

    constructor(data: IProximidadTutorItem, idGrupo: number) {
        super(data);
        this.IdGrupo = idGrupo;
    }

    getNombreCompleto() {
        return `${(this.Nombre || "").trim()} ${(this.ApPaterno || "").trim()} ${(this.ApMaterno || "").trim()}`;
    }

    getTiempoTranscurrido(): string {
        return _GetTiempoTranscurrido(this.FechaPosicion);
    }

    getEstadoString(): string {
        return _L(`ui.c_estado_proximidad.${this.Estado}`) || _L("general.unknown");
    }

    getDistanciaString(): string {
        if (this.DistanciaMetros < 1000) {
            return `${this.DistanciaMetros} m`;
        } else {
            return `${(this.DistanciaMetros / 1000).toFixed(1)} km`;
        }
    }

    getColorForEstado(): string {
        return `var(--color-proximidad-${this.Estado})` || "#000000";
    }

    getAlumnosAsignados(): IAlumno[] {
        return this.AlumnosAsignados
            .map(idAlumno => {
                return _DICT_GRUPO_ALUMNOS_MAP.get(this.IdGrupo)?.get(idAlumno);
            })
            .filter(alumno => alumno !== undefined) as IAlumno[];
    }

    /** Filtra los alumnos asignados en clase por los grupos especificados */
    filtrarAlumnosEnClasePorGrupo(idsGrupos: number[]): IAlumno[] {
        this.AlumnosFiltrados = this.getAlumnosAsignadosEnClaseEnGrupos(idsGrupos);
        return this.AlumnosFiltrados;
    }

    getAlumnosAsignadosEnClase(): IAlumno[] {
        return this.getAlumnosAsignados().filter(alumno => alumno.GrupoActivo != 0);
    }

    /** Devuelve los alumnos asignados en clase, si pertenecen a los grupos especificados */
    private getAlumnosAsignadosEnClaseEnGrupos(idsGrupos: number[]): IAlumno[] {
        return this.getAlumnosAsignadosEnClase().filter(alumno => idsGrupos.includes(Math.abs(alumno.GrupoActivo)));
    }

    getTieneAlumnosAsignadosEnClase(): boolean {
        return this.getAlumnosAsignados().some(alumno => !!alumno.GrupoActivo);
    }

    // getTieneAlumnosAsignadosEnClaseEnGrupoGlobal(): boolean {
    //     const globalGrupoId = _APP_DATA.userData.IdGrupo;
    //     return this.getAlumnosAsignados().some(alumno => alumno.GrupoActivo === globalGrupoId);
    // }

    // getAlumnosAsignadosEnClase(): IAlumno[] {
    //     const currentGrupoId = _APP_DATA.userData.IdGrupo;
    //     return this.getAlumnosAsignados().filter(alumno => alumno.GrupoActivo === currentGrupoId);
    // }
}
